import { createIcon } from "@chakra-ui/icons";

export const SignUpIcon = createIcon({
  displayName: "SignUpIcon",
  viewBox: "0 0 82 82",

  path: (
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <path
            fill="#FFF2CD"
            d="M79 40c0 21.723-17.61 39.333-39.333 39.333C17.943 79.333.333 61.723.333 40S17.943.667 39.667.667C61.39.667 79 18.277 79 40"
            transform="translate(-519 -615) translate(520 616)"
          />
          <path
            stroke="#FB0"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M77.816 50.882c2.068-7.164 2.124-14.995-.274-22.642C71.042 7.512 48.968-4.02 28.24 2.48 7.512 8.98-4.02 31.052 2.48 51.78c5.05 16.107 19.505 26.662 35.424 27.518"
            transform="translate(-519 -615) translate(520 616)"
          />
          <path
            fill="#FB0"
            d="M39.667 35.888c-5.606 0-10.167-4.56-10.167-10.167 0-5.606 4.56-10.166 10.167-10.166 5.606 0 10.166 4.56 10.166 10.166 0 5.606-4.56 10.167-10.166 10.167"
            transform="translate(-519 -615) translate(520 616)"
          />
          <path
            fill="#FFF2CD"
            d="M39.667 14.888c-5.974 0-10.834 4.86-10.834 10.833 0 5.974 4.86 10.834 10.834 10.834 5.973 0 10.833-4.86 10.833-10.834 0-5.973-4.86-10.833-10.833-10.833m0 1.333c5.246 0 9.5 4.254 9.5 9.5 0 5.247-4.254 9.5-9.5 9.5-5.247 0-9.5-4.253-9.5-9.5 0-5.246 4.253-9.5 9.5-9.5"
            transform="translate(-519 -615) translate(520 616)"
          />
          <path
            fill="#FB0"
            d="M26.68 59.97c-3.683 0-6.68-2.527-6.68-5.632v-5.757c0-.403.06-.819.186-1.27.92-5.469 6.564-9.59 13.147-9.59H46c6.582 0 12.227 4.121 13.148 9.59.125.451.185.867.185 1.27v5.757c0 3.105-2.997 5.631-6.68 5.631H26.68z"
            transform="translate(-519 -615) translate(520 616)"
          />
          <path
            fill="#FFF2CD"
            d="M46 37.055H33.333c-6.891 0-12.808 4.342-13.799 10.112-.135.498-.2.961-.2 1.414v5.757c0 3.473 3.295 6.298 7.346 6.298h25.973c4.052 0 7.347-2.825 7.347-6.298v-5.757c0-.453-.066-.916-.2-1.414-.992-5.77-6.909-10.112-13.8-10.112m0 1.333c6.39 0 11.66 3.974 12.496 9.069.103.362.17.736.17 1.124v5.757c0 2.73-2.705 4.965-6.013 4.965H26.68c-3.307 0-6.013-2.234-6.013-4.965v-5.757c0-.388.068-.762.17-1.124.837-5.095 6.106-9.069 12.496-9.069H46"
            transform="translate(-519 -615) translate(520 616)"
          />
          <path
            fill="#FB0"
            d="M12 23.333C5.75 23.333.667 18.25.667 12 .667 5.75 5.75.667 12 .667 18.25.667 23.333 5.75 23.333 12c0 6.25-5.084 11.333-11.333 11.333"
            transform="translate(-519 -615) translate(520 616)"
          />
          <path
            fill="#FFF2CD"
            d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 1.333c5.891 0 10.667 4.776 10.667 10.667S17.89 22.667 12 22.667 1.333 17.89 1.333 12 6.11 1.333 12 1.333"
            transform="translate(-519 -615) translate(520 616)"
          />
          <path
            fill="#FFF2CD"
            d="M11.333 18V6c0-.367.3-.667.667-.667.367 0 .667.3.667.667v12c0 .367-.3.667-.667.667-.367 0-.667-.3-.667-.667"
            transform="translate(-519 -615) translate(520 616)"
          />
          <path
            fill="#FFF2CD"
            d="M6 11.333h12c.367 0 .667.3.667.667 0 .367-.3.667-.667.667H6c-.367 0-.667-.3-.667-.667 0-.367.3-.667.667-.667"
            transform="translate(-519 -615) translate(520 616)"
          />
          <g>
            <path
              fill="#FFF2CD"
              d="M0.13 -0.001L3.887 3.756"
              transform="translate(-519 -615) translate(520 616) translate(50.667 57.333)"
            />
            <path
              stroke="#FB0"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M0.13 -0.001L3.887 3.756"
              transform="translate(-519 -615) translate(520 616) translate(50.667 57.333)"
            />
          </g>
          <g>
            <path
              fill="#FFF2CD"
              d="M0.347 0.037L4.103 3.793"
              transform="translate(-519 -615) translate(520 616) translate(55.333 54.667)"
            />
            <path
              stroke="#FB0"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M0.347 0.037L4.103 3.793"
              transform="translate(-519 -615) translate(520 616) translate(55.333 54.667)"
            />
          </g>
          <g>
            <path
              fill="#FFF2CD"
              d="M0.563 0.074L4.32 3.83"
              transform="translate(-519 -615) translate(520 616) translate(60 52)"
            />
            <path
              stroke="#FB0"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M0.563 0.074L4.32 3.83"
              transform="translate(-519 -615) translate(520 616) translate(60 52)"
            />
          </g>
          <path
            fill="#FFF2CD"
            d="M66.34 79.333c-.086 0-.172-.003-.258-.01-.03-.002-.06-.006-.09-.012-.066-.015-.132-.034-.197-.054-.08-.024-.213-.08-.278-.132-6.31-4.984-17.672-6.092-17.787-6.103-.05-.005-.1-.015-.15-.032-1.41-.47-2.061-1.93-1.547-3.473.45-1.352 2.138-2.334 4.013-2.334.663 0 1.523.07 2.295.148L39.808 54.8c-1.295-1.296-1.295-3.404 0-4.699.628-.627 1.462-.973 2.35-.973.887 0 1.722.346 2.35.973l5.254 5.255c.1-.707.425-1.36.94-1.874.627-.628 1.46-.973 2.349-.973.716 0 1.396.225 1.963.64.093-.725.42-1.395.947-1.92.626-.629 1.46-.974 2.348-.974.717 0 1.399.225 1.966.643.09-.704.405-1.384.944-1.924.628-.627 1.462-.973 2.35-.973.887 0 1.722.346 2.349.973l7.513 7.513c.502.502 2.09 3.163 3.268 5.474 2.692 5.285 1.964 6.012 1.615 6.361L67.78 78.855c-.048.048-.103.089-.163.12l-.081.043c-.078.043-.157.084-.238.121-.231.084-.415.134-.6.172-.026.006-.052.008-.078.011-.094.007-.187.011-.28.011"
            transform="translate(-519 -615) translate(520 616)"
          />
          <path
            fill="#FB0"
            d="M63.568 47.333c-1.066 0-2.067.415-2.82 1.169-.402.401-.708.874-.906 1.39-.479-.2-.998-.305-1.532-.305-1.066 0-2.068.415-2.822 1.169-.407.407-.708.883-.902 1.39-.48-.2-1-.305-1.535-.305-1.066 0-2.068.415-2.821 1.168-.328.328-.587.7-.776 1.095l-4.476-4.475c-.754-.754-1.755-1.169-2.82-1.169-1.066 0-2.068.415-2.822 1.169-.754.753-1.168 1.755-1.168 2.821 0 1.065.415 2.067 1.168 2.82l11.259 11.26c-.192-.009-.377-.013-.55-.013-2.187 0-4.097 1.148-4.645 2.79-.636 1.908.192 3.724 1.97 4.316.097.032.197.054.298.062.112.011 11.285 1.104 17.435 5.963.137.108.293.188.46.235l.04.013c.085.025.17.05.257.067.055.012.111.02.168.024.105.009.209.013.313.013.11 0 .22-.005.33-.013.053-.004.106-.012.159-.022.215-.044.429-.103.636-.176.035-.012.07-.026.105-.042.096-.043.19-.093.283-.143l.07-.037c.121-.063.231-.144.327-.24l10.534-10.534c.877-.876.933-2.376-1.492-7.136-1.106-2.171-2.77-5.022-3.391-5.643l-7.513-7.512c-.753-.754-1.755-1.169-2.82-1.169m0 1.334c.68 0 1.359.259 1.877.778l7.513 7.512c.751.752 6.01 9.767 4.883 10.893L67.308 78.384c-.094.05-.188.103-.285.148-.15.053-.302.094-.457.125-.075.006-.15.01-.225.01-.069 0-.139-.003-.207-.008-.07-.015-.136-.038-.204-.058-6.543-5.169-18.138-6.243-18.138-6.243-1.127-.375-1.503-1.503-1.127-2.63.375-1.127 1.878-1.878 3.38-1.878 1.503 0 4.133.376 4.133.376L40.279 54.328c-1.037-1.037-1.037-2.72 0-3.757.52-.518 1.199-.778 1.879-.778.679 0 1.359.26 1.878.778l7.136 7.138c-1.036-1.038-1.036-2.72 0-3.756.52-.52 1.199-.778 1.879-.778.68 0 1.36.258 1.878.778l1.503 1.502c-1.038-1.038-1.038-2.719 0-3.756.518-.519 1.198-.778 1.878-.778.68 0 1.359.259 1.878.778L61.69 53.2c-1.037-1.038-1.037-2.719 0-3.756.519-.519 1.198-.778 1.878-.778"
            transform="translate(-519 -615) translate(520 616)"
          />
        </g>
      </g>
    </g>
  ),
});

export const SourceIcon = createIcon({
  displayName: "SourceIcon",
  viewBox: "0 0 82 82",

  path: (
    <g fill="none" fillRule="evenodd">
      <g>
        <g transform="translate(-919 -615) translate(920 616)">
          <circle cx="40" cy="40" r="40" stroke="#0CA" strokeWidth="2" />
          <circle cx="40" cy="40" r="26.667" stroke="#0CA" strokeWidth="2" />
          <circle cx="40" cy="40" r="13.333" stroke="#0CA" strokeWidth="2" />
          <circle cx="66.667" cy="40" r="3.333" fill="#0CA" />
          <circle cx="58" cy="58.667" r="3.333" fill="#0CA" />
          <circle cx="20" cy="5.333" r="3.333" fill="#0CA" />
          <circle cx="11.333" cy="67.333" r="3.333" fill="#0CA" />
          <circle cx="27.333" cy="40" r="3.333" fill="#0CA" />
        </g>
      </g>
    </g>
  ),
});

export const OffersIcon = createIcon({
  displayName: "OffersIcon",
  viewBox: "0 0 62 82",

  path: (
    <>
      <defs>
        <linearGradient id="zht3ib8dja" x1="50%" x2="50%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#D9F1FF" />
          <stop offset="100%" stopColor="#FFF" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <path
                fill="#D9F1FF"
                d="M41.653.001v59.166c0 1.114-.889 2.018-1.985 2.018H.001"
                transform="translate(-1329 -615) translate(1330 616) translate(17.851 18.154)"
              />
              <path
                stroke="#09E"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M41.653.001v59.166c0 1.114-.889 2.018-1.985 2.018H.001"
                transform="translate(-1329 -615) translate(1330 616) translate(17.851 18.154)"
              />
            </g>
            <g>
              <path
                fill="#D9F1FF"
                d="M41.653.001v59.166c0 1.114-.889 2.018-1.985 2.018H.001"
                transform="translate(-1329 -615) translate(1330 616) translate(9.917 10.085)"
              />
              <path
                stroke="#09E"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M41.653.001v59.166c0 1.114-.889 2.018-1.985 2.018H.001"
                transform="translate(-1329 -615) translate(1330 616) translate(9.917 10.085)"
              />
            </g>
            <path
              fill="url(#zht3ib8dja)"
              d="M41.652 0H1.985C.889 0 0 .904 0 2.018v43.606l9.98 17.578h31.672c1.096 0 1.984-.904 1.984-2.018V2.018C43.636.904 42.748 0 41.652 0"
              transform="translate(-1329 -615) translate(1330 616)"
            />
            <path
              stroke="#09E"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M41.652 0H1.985C.889 0 0 .904 0 2.018v43.606l9.98 17.578h31.672c1.096 0 1.984-.904 1.984-2.018V2.018C43.636.904 42.748 0 41.652 0z"
              transform="translate(-1329 -615) translate(1330 616)"
            />
            <path
              fill="#09E"
              d="M9.98 47.643c0-1.115-.89-2.019-1.985-2.019H0l9.98 17.578v-15.56zM21.818 6.051L24.504 11.584 30.508 12.472 26.163 16.779 27.189 22.86 21.818 19.989 16.448 22.86 17.474 16.779 13.128 12.472 19.133 11.584z"
              transform="translate(-1329 -615) translate(1330 616)"
            />
            <path
              stroke="#09E"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M21.818 6.051L24.504 11.584 30.508 12.472 26.163 16.779 27.189 22.86 21.818 19.989 16.448 22.86 17.474 16.779 13.128 12.472 19.133 11.584zM6.612 32.273L37.025 32.273M6.612 38.997L37.025 38.997M16.529 45.721L37.025 45.721M16.529 52.444L37.025 52.444"
              transform="translate(-1329 -615) translate(1330 616)"
            />
          </g>
        </g>
      </g>
    </>
  ),
});

export const ArrowForwardIcon = createIcon({
  displayName: "ArrowForwardIcon",
  viewBox: "0 0 24 24",

  path: (
    <g>
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z" />
    </g>
  ),
});

export const ArrowBackwardIcon = createIcon({
  displayName: "ArrowForwardIcon",
  viewBox: "0 0 24 24",

  path: (
    <g>
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M10.828 12l4.95 4.95-1.414 1.414L8 12l6.364-6.364 1.414 1.414z" />
    </g>
  ),
});

export const LinkedInIcon = createIcon({
  displayName: "LinkedInIcon",
  viewBox: "0 0 24 24",

  path: (
    <g>
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        fill="currentColor"
        d="M6.94 5a2 2 0 1 1-4-.002 2 2 0 0 1 4 .002zM7 8.48H3V21h4V8.48zm6.32 0H9.34V21h3.94v-6.57c0-3.66 4.77-4 4.77 0V21H22v-7.93c0-6.17-7.06-5.94-8.72-2.91l.04-1.68z"
      />
    </g>
  ),
});

export const TwitterIcon = createIcon({
  displayName: "TwitterIcon",
  viewBox: "0 0 24 24",

  path: (
    <g>
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        fill="currentColor"
        d="M22.162 5.656a8.384 8.384 0 0 1-2.402.658A4.196 4.196 0 0 0 21.6 4c-.82.488-1.719.83-2.656 1.015a4.182 4.182 0 0 0-7.126 3.814 11.874 11.874 0 0 1-8.62-4.37 4.168 4.168 0 0 0-.566 2.103c0 1.45.738 2.731 1.86 3.481a4.168 4.168 0 0 1-1.894-.523v.052a4.185 4.185 0 0 0 3.355 4.101 4.21 4.21 0 0 1-1.89.072A4.185 4.185 0 0 0 7.97 16.65a8.394 8.394 0 0 1-6.191 1.732 11.83 11.83 0 0 0 6.41 1.88c7.693 0 11.9-6.373 11.9-11.9 0-.18-.005-.362-.013-.54a8.496 8.496 0 0 0 2.087-2.165z"
      />
    </g>
  ),
});

export const FacebookIcon = createIcon({
  displayName: "FacebookIcon",
  viewBox: "0 0 24 24",

  path: (
    <g>
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        fill="currentColor"
        d="M14 13.5h2.5l1-4H14v-2c0-1.03 0-2 2-2h1.5V2.14c-.326-.043-1.557-.14-2.857-.14C11.928 2 10 3.657 10 6.7v2.8H7v4h3V22h4v-8.5z"
      />
    </g>
  ),
});

export const HamburgerIcon = createIcon({
  displayName: "HamburgerIcon",
  viewBox: "0 0 24 24",

  path: (
    <g>
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M3 4h18v2H3V4zm0 7h18v2H3v-2zm0 7h18v2H3v-2z" />
    </g>
  ),
});

export const CloseIcon = createIcon({
  displayName: "CloseIcon",
  viewBox: "0 0 24 24",

  path: (
    <g>
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z" />
    </g>
  ),
});
